import React from "react";
import styles from "./HeroSection.module.css";
import { aliens } from "../../images";

const HeroSection = () => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.imageContainer}>
        <img src={aliens} alt="Aliens" className={styles.image} />
      </div>
      <h2 className={styles.heading}>Super Aliens</h2>
      <div className={styles.whiteList}>
        <span className={styles.circle} />
        <span>Whitelist</span>
      </div>
      <p className={styles.text}>
        Terra ALiens is a collection of NFTsbuilt on the Terra blockchain. We
        are biulding a Web3 Brand and partnering with the best in the business.
        Holder utility will be unlike anything you have never seen before.Now
        you can become a part of it.
      </p>
    </section>
  );
};

export default HeroSection;
